import { sendUpdateUserMarketingOptIn } from "@/models/socket/user.model";
import { AppContext } from "@/services/AppContext/appContext";
import { Checkbox } from "@/shadcn/components/ui/checkbox";
import { Label } from "@/shadcn/components/ui/label";
import { genericFailureToast, genericSuccessToast } from "@/utils/utils.util";
import React, { useContext, useState } from "react";

type MarketingOptInProps = {
  initialValue: boolean;
};

const MarketingOptIn: React.FC<MarketingOptInProps> = ({ initialValue }) => {
  const [optIn, setOptIn] = useState(initialValue);
  const [submitting, setSubmitting] = useState(false);
  const { setUserShouldUpdateAccount } = useContext(AppContext);

  async function handleOptInChange(checked: boolean) {
    setOptIn(checked);
    setSubmitting(true);
    // make API call to update the user's marketing opt-in status
    const result = await sendUpdateUserMarketingOptIn(checked);
    if (result.rStatus === "error") {
      setSubmitting(false);
      console.error("Failed to update marketing opt-in status:", result.rData);
      genericFailureToast(
        result.rData ||
          "Failed to update marketing opt-in status. Please try again later."
      );
      setOptIn(!checked);
      return;
    }

    setSubmitting(false);
    genericSuccessToast("Marketing opt-in status updated successfully!");
    setUserShouldUpdateAccount(false);
  }

  return (
    <Label
      className={`mt-2 flex items-center gap-2 text-base ${submitting ? "cursor-not-allowed opacity-50 duration-500" : ""}`}
    >
      <Checkbox
        checked={optIn}
        onCheckedChange={(checked) => handleOptInChange(Boolean(checked))}
        disabled={submitting}
      />
      <span className="select-none">Receive marketing communications</span>
    </Label>
  );
};

export default MarketingOptIn;
